module.exports = __webpack_public_path__ + "img/w3_circle_right_dark.0fe33294.png";